<template>
    <router-view></router-view>
</template>
<script setup lang="ts">
import { controlDeferred } from '@eureka/utils/control';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';

async function openEditionUpgradeFirstLogin() {
    const { is_first_login_after_try_end } = await controlDeferred.promise;
    if (is_first_login_after_try_end) {
        import('@eureka/shared/edition-upgrade').then((mod) => {
            mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_SEEK, EurekaPackageType.AIR_COMMERCIAL);
        });
    }
}

openEditionUpgradeFirstLogin();

</script>
